import { createEffect, createStore, sample } from 'effector';
import { checkSessionFx } from '../../entities/session';
import { authApi } from '../../shared/api/auth';
import { ApiRequestError } from '../../shared/api/http';
import { router, routes } from '../../shared/routing';

/*
 * Magic-link landing page: confirms the token with a POST (so mail scanners that prefetch links
 * can't use it), refreshes the session and returns to where sign-in started.
 */

export const verifyFx = createEffect((token: string) => authApi.verifyMagicLink(token));

export const $verifyError = createStore<string | null>(null)
  .on(verifyFx.failData, (_, error) => (error instanceof ApiRequestError ? error.code : 'generic'))
  .reset(routes.authVerify.opened);

sample({
  clock: routes.authVerify.opened,
  filter: ({ query }) => typeof query.token === 'string' && query.token.length > 0,
  fn: ({ query }) => String(query.token),
  target: verifyFx,
});
sample({
  clock: routes.authVerify.opened,
  filter: ({ query }) => typeof query.token !== 'string' || query.token.length === 0,
  fn: () => 'link_invalid',
  target: $verifyError,
});

const goToFx = createEffect(async (returnTo: string) => {
  await checkSessionFx();
  return returnTo;
});
sample({ clock: verifyFx.doneData, fn: ({ returnTo }) => returnTo, target: goToFx });
sample({
  clock: goToFx.doneData,
  fn: (path) => ({ path, params: {}, query: {}, method: 'replace' as const }),
  target: router.push,
});
